"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class Switch
 * @description form Switch component
 */
var React = require("react");
var CheckBox_1 = require("./CheckBox");
var classNames = require("classnames");
var util_1 = require("../../../utils/util");
/**
 * OUI Switch component.
 *
 * @oui-component Switch
 */
var Switch = function (_a) {
    var testId = _a.testId, stateLabel = _a.stateLabel, rest = __rest(_a, ["testId", "stateLabel"]);
    var switchClasses = classNames("oui-react-slider", { "slider-cursor": !rest.disabled });
    var spanClasses = classNames("switch-right-label", { "switch-label-disabled": rest.disabled });
    var inputRef = React.createRef();
    var onClickHandler = React.useCallback(function () {
        inputRef.current && inputRef.current.click();
    }, [inputRef]);
    return (React.createElement("span", __assign({ "data-test-id": testId }, util_1.ariaProps(rest)),
        React.createElement("span", { className: "oui-react-switch", onClick: onClickHandler },
            React.createElement(CheckBox_1.default, __assign({ inputRef: inputRef }, rest)),
            React.createElement("span", { className: switchClasses })),
        stateLabel && (React.createElement("span", { className: spanClasses }, stateLabel))));
};
exports.default = Switch;
//# sourceMappingURL=Switch.js.map